import { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import { GoogleAdsense } from 'src/lib/components/GoogleAdsense.component';
import { Pagination } from 'src/lib/components/Pagination.component';
import { Select } from 'src/lib/components/Select.component';
import { VideoPlayer, VideoPlayerRef } from 'src/lib/components/VideoPlayer.component';
import { fpost } from 'src/lib/fetch';
import { ResponseDocuments } from 'src/lib/response/response';
import { addQueryAdsParams } from 'src/redux/slices/query-ads-params.slice';
import { RootState } from 'src/redux/store';
import { AdEntity } from '../dto/ads.entity';
import { QueryAdsReq } from '../dto/ads.req';

export function AdsList() {
  const [ads, setAds] = useState<ResponseDocuments<AdEntity>>();

  const [pagination, setPagination] = useState<{ page: number; pageLimit: number }>({ page: 0, pageLimit: 20 });
  const pageLimitTimeout = useRef<NodeJS.Timeout>();

  const ePageLimitLabelSpan = useRef<HTMLSpanElement>(null);

  const eVideoRef = useRef<(VideoPlayerRef | null)[]>([]);

  const queryAdsFilter = useSelector((root: RootState) => root.queryAdsParamsReducer);

  const navigate = useNavigate();

  const dispatch = useDispatch();

  useEffect(() => {
    setPagination((prev) => ({ ...prev, page: 0 }));
  }, [queryAdsFilter]);

  useEffect(() => {
    fpost<QueryAdsReq, typeof ads>('media/query', {
      body: {
        filter: queryAdsFilter,
        currentPage: pagination.page || 0,
        pageLimit: pagination.pageLimit,
      },
    }).then((res) => setAds(res[1]));
  }, [queryAdsFilter, pagination]);

  return (
    <div id="ad-page-list" className="block w-full pl-[8.5rem] text-center md:pl-[17rem]">
      {/* <GoogleAdsense className="border" slotType="hMultiplex" /> */}
      <div className="m-2 flex flex-sm-nowrap flex-wrap justify-center gap-4 md:flex-nowrap md:justify-end select-area">
        {ads && (
          <Select
            className="rounded-md"
            labelProps={{
              children: '表示件',
              className: 'mb-0 mr-4',
            }}
            containerProps={{
              className: 'flex items-center justify-end',
            }}
            onChange={(e) => {
              setPagination((prev) => ({ ...prev, pageLimit: Number(e.target.value) }));
            }}>
            <option value="20">20</option>
            <option value="50">50</option>
            <option value="100">100</option>
            <option value="200">200</option>
          </Select>
        )}
        <Select
          className="rounded-md"
          labelProps={{
            children: '並び替え条件',
            className: 'mb-0 mr-4',
          }}
          containerProps={{
            className: 'flex items-center justify-end',
          }}
          onChange={(e) => {
            dispatch(
              addQueryAdsParams({
                key: 'sortBy',
                value: e.target.value,
              }),
            );
          }}>
          <option value="desc_time">aa新着順</option>
          <option value="asc_time">投稿順</option>
        </Select>
      </div>

      {ads?.data.length ? (
        <>
          <div
            className="mt-4 grid gap-2 card-items"
            style={{
              // gridTemplateColumns: 'repeat(auto-fit, 16rem)',
            }}>
            {ads.data.map((ad, i) => {
              let captureURL = new URL(`http://${window.location.host}/no-image-svgrepo-com.svg`);
              try {
                captureURL = new URL(ad.capture);
              } catch {
                /* empty */
              }

              captureURL.searchParams.delete('dl');
              captureURL.searchParams.append('raw', '1');

              const isVideoUrl =
                '|.ty+|.str|.swf|.aep|.mkv|.pz|.plot|.sfd|.kine|.drp|.psv|.prproj|.piv|.veg|.vproj|.inp|.pic|.anm|.cpvc|.plotdoc|.scm|.wlmp|.msdvd|.aec|.bik|.kdenlive|.mswmm|.dcr|.webm|.amc|.scm|.vpj|.wpl|.dir|.mp4|.fcp|.fbr|.evo|.srt|.dcr|.vob|.mse|.rmvb|.sbt|.clpi|.flc|.sub|.ssf|.vsp|.pac|.ifo|.3gp|.mxf|.cine|.dmsm|.rec|.camproj|.mvd|.ivr|.dmx|.vp6|.vtt|.alpx|.sqz|.m4u|.dpa|.av1|.wmmp|.meta|.tsv|.mpeg|.trp|.swi|.gts|.rcd|.db2|.aepx|.mgv|.screenflow|.mvp|.mpv|.amx|.mani|.d3v|.hdmov|.rms|.video|.ismv|.3gp2|.viv|.wmv|.asf|.vc1|.ogv|.flv|.psh|.dmsm3d|.ncor|.pmf|.ser|.jtv|.ale|.mys|.zm2|.siv|.meps|.rcut|.g2m|.arcut|.exi|.gfp|.tvshow|.mpsub|.m2ts|.dv4|.mproj|.dxr|.mp4v|.mp4.infovid|.ts|.mob|.dat|.m1v|.cme|.mp5|.idx|.scc|.zmv|.iva|.mj2|.psb|.m2t|.dream|.mepx|.m4v|.rm|.mpeg4|.dzm|.trec|.camrec|.tix|.theater|.smv|.mjpg|.bk2|.mnv|.wp3|.stx|.vro|.awlive|.f4p|.mpg|.xmv|.vgz|.wvm|.dash|.mov|.dzp|.dv|.tp|.mts|.pds|.int|.dvr-ms|.dvr|.tmv|.mmp|.sedprj|.pclx|.avv|.dzt|.ircp|.mv|.ppj|.ffd|.avb|.dmb|.cst|.m4s|.zm3|.ktn|.kmproject|.fbr|.izz|.sfvidcap|.camv|.fli|.vii|.qtch|.m75|.mep|.izzy|.vid|.264|.bnp|.playlist|.wvx|.avchd|.dav|.sbk|.cpi|.3mm|.vep|.h264|.3g2|.mp2v|.xesc|.sfera|.m15|.264|.mvp|.rdb|.mpeg2|.bsf|.jdr|.60d|.xvid|.lvix|.d2v|.ddat|.san|.pgi|.890|.yuv|.aaf|.ism|.movie|.g64x|.g64|.media|.f4v|.mpv2|.mpl|.3gpp|.jss|.pdrproj|.mp21|.mvex|.tbc|.r3d|.qtl|.mmv|.wve|.dck|.hdv|.mk3d|.dnc|.xlmv|.rsx|.tsp|.pro|.f4f|.m4f|.vcr|.bdmv|.vp3|.divx|.hevc|.m2p|.ogm|.nut|.moi|.swt|.smk|.wcp|.nuv|.rv|.k3g|.spl|.ogx|.wm|.xml|.kmv|.avi|.dpg|.bu|.ced|.dvdmedia|.3gpp2|.rum|.tvlayer|.tdt|.lrec|.3p2|.exo|.wrf|.mpe|.787|.arf|.wmd|.rmd|.bdt3|.mtv|.flic|.tivo|.m2a|.vp7|.bmc|.nfv|.tvs|.lsx|.lrv|.mpg4|.gvi|.moov|.aqt|.tpd|.dmsd|.rmp|.aetx|.jmv|.mjp|.prel|.zoom|.wxp|.f4m|.mvc|.v264|.nvc|.asx|.imovieproj|.y4m|.bvr|.movie|.ttxt|.irf|.ajp|.ftc|.ave|.avp|.smil|.fvm|.wtv|.bdm|.tvrecording|.otrkey|.ntp|.mve|.mv8|.axv|.wot|.m4e|.avd|.prtl|.imovielibrary|.m2v|.vse|.pjs|.avs|.vcv|.flh|.sub|.evo|.m21|.pxv|.hkm|.n3r|.vr|.rcrec|.sbz|.tpr|.imoviemobile|.roq|.fpdx|.peg|.vbc|.sdv|.rvid|.vdr|.rvl|.bmk|.plproj|.zeg|.mpgindex|.ismc|.cmproj|.photoshow|.cmmtpl|.zm1|.gxf|.tod|.tda3mt|.ivf|.dvx|.dvt|.braw|.projector|.lfpackage|.ttml|.m21|.ssm|.orv|.qt|.insv|.vivo|.mpeg1|.aegraphic|.mpl|.sec|.mt2s|.wmx|.edl|.par|.sec|.vcpf|.qtm|.rmd|.yog|.w32|.pns|.gifv|.gcs|.amv|.xel|.crec|.vix|.clk|.nsv|.av|.thp|.pvr|.am|.ravi|.pssd|.dv-avi|.fcproject|.vfz|.smi|.anim|.ssa|.vfw|.seq|.proqc|.fcarch|.byu|.m1pg|.blz|.mpc|.vs4|.vlab|.bs4|.qsv|.mxv|.vmd|.modd|.mvb|.mpls|.dif|.mod|.tp0|.qtz|.viewlet|.xfl|.bix|.gl|.spryzip|.wsve|.vem|.vdo|.ezt|.jts|.axm|.dmss|.imovieproject|.aet|.cmrec|.aecap|.vf|.dad|.dlx|.ffm|.pro4dvd|.cmmp|.vdx|.xej|.mpg2|.cvc|.svi|.exp|.usf|.stl|.smi|.moff|.fbz|.lsf|.msh|.fvt|.jv|.seq|.dce|.cmv|.cip|.h261|.ivs|.scn|.pva|.eyetv|.avm|.h265|.lxf|.gom|.avs|.mqv|.wgi|.rcproject|.rmv|.avr|.eye|.mjpeg|.dmsd3d|.tdx|.ty|.ismclip|.mvy|.avs|.wfsp|.anydesk|.bik2|.vmlf|.cam|.vmlt|.cdxl|.drc|.vsr|.vp5|.anx|.pmp|.pro5dvd|.el8|.cx3|.camtemplate|.skm|.avc|.bdt2|.rts|.qtindex|.gvp|.mp21|.tid|.qsmd|.rp|.mpf|.sml|.p64|.movie|.lvf|.jnr|.flx|.vsh|.h263|.av3|.kux|.vft|.grasp|.ml20|.h262|.paf|.dsy|.tgv|.tgq|.rpl|.rl2|.mvi|.pmv|.cel|.rts|.pjr|'.includes(
                  `|.${captureURL.pathname.split('.').at(-1) || ''}|`,
                );

              return (
                <div className="flex max-w-[20rem] flex-col gap-2 w-card" key={i}>
                  <div className="group mb-4 rounded-lg border-8 border-double border-white shadow-md">
                    <div className="flex gap-2 p-2">
                      <img
                        className="h-6 w-6"
                        src={
                          {
                            Facebook: `http://${window.location.host}/assets/facebook-svgrepo-com.svg`,
                            Instagram: `http://${window.location.host}/assets/instagram-svgrepo-com.svg`,
                            Twitter: `http://${window.location.host}/assets/twitter-svgrepo-com.svg`,
                            LINE: `http://${window.location.host}/assets/line-svgrepo-com.svg`,
                            TikTok: `http://${window.location.host}/assets/tiktok-svgrepo-com.svg`,
                          }[ad.mediaSource]
                        }
                      />
                      <span className="text-blue font-medium">{`${ad.year} 年 ${ad.month} 月 ${ad.day} 日`}</span>
                    </div>
                    {ad.material === '静止画' && !isVideoUrl ? (
                      <div className="relative overflow-hidden rounded-b-lg">
                        <Link to={`ad/${ad._id}`}>
                          <img
                            src={captureURL.href}
                            style={{
                              height: '32rem',
                            }}
                            className="cursor-pointer object-cover transition duration-1000 ease-in-out group-hover:scale-125 group-hover:brightness-75"
                          />
                          <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 cursor-pointer opacity-0 transition group-hover:opacity-100">
                            <svg
                              className="h-10 w-10 text-white"
                              viewBox="0 0 24 24"
                              strokeWidth={1.5}
                              stroke="currentColor"
                              fill="none"
                              strokeLinecap="round"
                              strokeLinejoin="round">
                              <path stroke="none" d="M0 0h24v24H0z" /> <line x1="15" y1="8" x2="15.01" y2="8" />
                              <rect x="4" y="4" width="16" height="16" rx="3" />{' '}
                              <path d="M4 15l4 -4a3 5 0 0 1 3 0l 5 5" /> <path d="M14 14l1 -1a3 5 0 0 1 3 0l 2 2" />
                            </svg>
                          </div>
                        </Link>
                      </div>
                    ) : (
                      <div className="relative cursor-pointer overflow-hidden">
                        <Link to={`ad/${ad._id}`}>
                          <VideoPlayer
                            containerProps={{
                              className: 'transition duration-1000 ease-in-out group-hover:brightness-75',
                              onMouseEnter: () => {
                                eVideoRef.current[i]?.setProps({ playing: true, muted: true });
                              },
                              onMouseLeave: () => {
                                eVideoRef.current[i]?.setProps({ playing: false, muted: true });
                              },
                            }}
                            url={captureURL.href}
                            width="auto"
                            height="32rem"
                            ref={(ref) => (eVideoRef.current[i] = ref)}
                            pip
                          />
                          <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 cursor-pointer opacity-0 transition group-hover:opacity-100">
                            <svg
                              className="h-10 w-10 text-white"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="currentColor"
                              strokeWidth={1.5}
                              strokeLinecap="round"
                              strokeLinejoin="round">
                              {' '}
                              <polygon points="23 7 16 12 23 17 23 7" />{' '}
                              <rect x="1" y="5" width="15" height="14" rx="2" ry="2" />
                            </svg>
                          </div>
                        </Link>
                      </div>
                    )}
                  </div>
                </div>
              );
            })}
          </div>
          <div className="grid grid-cols-12 justify-items-center px-0 py-4 xs-px-20 md:px-20">
            <div className="inline-flex items-end gap-0.5">
              <span className="text-4xl leading-9 text-amber-500">{ads.total}</span>
              <span className="text-lg text-black">件</span>
            </div>
            <Pagination
              className="col-span-11"
              total={Math.ceil(ads.total / (ads.pageLimit || 1))}
              hops="lastpoint"
              onPageChange={(page) => {
                setPagination((prev) => ({ ...prev, page: page - 1 }));
              }}
            />
          </div>
        </>
      ) : (
        <>No data</>
      )}
      {/* <GoogleAdsense className="my-4 border" slotType="hMultiplex" /> */}
    </div>
  );
}
